import React, { useContext, useEffect, useState } from "react";
import {
  Form,
  Icon,
  Label,
  Modal,
  Search,
  Table,
  Button,
  Popup,
} from "semantic-ui-react";
import { AppContext } from "../../../Context/AppContext";
import { useToasts } from "react-toast-notifications";
import { useHistory, useParams } from "react-router-dom";
import {
  acceptOrRejectOrder,
  deleteOrder,
  getAllOrdersOfUser,
  viewPdfURL,
  downloadPestTracker,
} from "../../../constants";
import MDL_PROGRESS from "../../../components/cmp-progress/cmp-progress";
import CMP_PDF_VIEWER from "../../../components/cmp-pdf-viewer/cmp-pdf-viewer";
import AppPagination from "../../../components/cmp-pagination/Pagination";
import { isValid } from "date-fns";
import moment from "moment";
import { useLocation } from "react-router-dom/cjs/react-router-dom.min";
import MDL_DELETE from "../../../components/cmp-delete-modal/cmp-delete-modal";

export default function BuildingOrders(renderedByTab = false) {
  const { bInfo, userInfo, orderFilter, appVersion, isAppVersionOutdated } =
    useContext(AppContext);
  const [var_app_version] = appVersion;
  const [, set_is_app_version_outdated] = isAppVersionOutdated;
  const [searchQuery, setSearchQuery] = useState("");
  const [searchNull, setSearchNull] = useState(false);
  const [var_mdl_progress, set_mdl_progress] = useState(false);
  const [selected_buildingOrder, setSelectedBuildingOrder] = useState(null);
  const [current_sort, set_current_sorted] = useState({
    sort_by: "",
    sort_by_value: "",
  });
  const params = useParams();
  const { search } = useLocation();
  const searchParams = new URLSearchParams(search);
  const searchParam = searchParams.get("s_id");
  const [building_info, setBuildingInfo] = bInfo;
  const [user, setUser] = userInfo;
  const [orders, setOrders] = useState([]);
  const [totalOrders, setTotalOrders] = useState(0);
  const [page, setPage] = useState(1);
  const [limit, setLimit] = useState(10);
  const [selected_order, set_selected_order] = useState();
  const [pdf_url, set_pdf_url] = useState();
  const [open_pdf_viewer, set_open_pdf_viewer] = useState(false);
  const [open_delete_modal, set_open_delete_modal] = useState(false);
  const [order_to_delete, set_order_to_delete] = useState(null);
  const [sortBy, setSortBy] = useState(3);
  const [var_order_filter, set_order_filter] = orderFilter;
  const history = useHistory();
  const { addToast } = useToasts();

  useEffect(() => {
    if (searchParam) {
      setSelectedBuildingOrder(searchParam);
    }
  }, [searchParam]);

  useEffect(() => {
    setSortBy(var_order_filter);
  }, [var_order_filter]);

  useEffect(() => {
    const delayDebounceFn = setTimeout(async () => {
      // Send Axios request here
      // getListOfCustomers();
      if (searchQuery || searchNull) {
        set_mdl_progress(true);
        await getBuildingOrders(1, limit);
        set_mdl_progress(false);
      }
    }, 1200);

    return () => clearTimeout(delayDebounceFn);
  }, [searchQuery]);

  useEffect(() => {
    if (selected_buildingOrder && page > 0) {
      getBuildingOrders(page, limit);
    }
  }, [limit, page, selected_buildingOrder]);

  useEffect(() => {
    if (selected_buildingOrder) {
      setPage(1);
      getBuildingOrders(1, limit);
    } else if (searchParam) {
      if (sortBy === 2 || sortBy === 4) {
        setSearchQuery("");
      }
      setSelectedBuildingOrder(searchParam);
      setPage(1);
      // getBuildingOrders(1, limit);
    }

    // Only update sorting if it actually changes to prevent re-renders
    // if (
    //   current_sort?.sort_by === "order_number" &&
    //   (sortBy === 2 || sortBy === 4) &&
    //   (current_sort?.sort_by !== "order_date_time" ||
    //     current_sort?.sort_by_value !== "DESC")
    // ) {
    //   set_current_sorted({
    //     sort_by: "order_date_time",
    //     sort_by_value: "DESC",
    //   });
    // } else if (
    //   (sortBy === 3 || sortBy === 0 || sortBy === 1) &&
    //   (current_sort?.sort_by !== "order_number" ||
    //     current_sort?.sort_by_value !== "DESC")
    // ) {
    //   set_current_sorted({
    //     sort_by: "order_number",
    //     sort_by_value: "DESC",
    //   });
    // }
  }, [sortBy, current_sort]); // Remove current_sort from dependency array

  // Separate API call logic into another useEffect
  // useEffect(() => {
  //   if (selected_buildingOrder && page > 0) {
  //     console.log("4")
  //     getBuildingOrders(page, limit);
  //   }
  // }, [limit, page, selected_buildingOrder, current_sort]); // Keep dependencies relevant

  function doSearch(event) {
    const value = event.target.value.toString().toLowerCase();
    if (value) {
      setSearchNull(false);
    } else {
      setSearchNull(true);
    }
    setSearchQuery(value);
  }

  async function getBuildingOrders(page_no, limit_range) {
    // if (
    //   current_sort?.sort_by === "order_number" &&
    //   (sortBy === 2 || sortBy === 4)
    // ) {
    //   return true;
    // }
    if (selected_buildingOrder) {
      set_mdl_progress(true);
      const requestHeaders = {
        headers: {
          entityid: selected_buildingOrder,
          appversion: var_app_version,
        },
      };
      const params = new URLSearchParams();
      if (
        searchQuery &&
        searchQuery !== "0" &&
        !(sortBy === 2 || sortBy === 4)
      ) {
        params.append("search", searchQuery);
      }
      if (current_sort?.sort_by) {
        params.append("order_by", current_sort.sort_by);
      }
      if (current_sort?.sort_by_value) {
        params.append("order_by_value", current_sort.sort_by_value);
      }
      params.append("page", page_no || page);
      params.append("sort_by", parseInt(sortBy));
      const finalLimit = limit_range
        ? limit_range === "all"
          ? 99999
          : limit_range
        : limit === "all"
          ? 99999
          : limit;
      params.append("limit", finalLimit);
      params.append("is_admin", "false");
      params.append("id", selected_buildingOrder);

      await fetch(`${getAllOrdersOfUser}?${params.toString()}`, requestHeaders)
        .then((response) => response.json())
        .then((res) => {
          set_mdl_progress(false);
          var ordersFetch = [];
          if (res.statusCode === 200) {
            ordersFetch = res.body.data;
            setTotalOrders(res.body.total_count);
            // if(res.body && res.body.data && res.body.data.length === 0){
            //     //setPage(page-1)
            // }
          } else {
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            ordersFetch = [];
          }
          if (page_no && page_no > 1) ordersFetch = [...orders, ...ordersFetch];
          setOrders(ordersFetch);
        })
        .catch((error) => {
          set_mdl_progress(false);
          console.error("Error:", error);
        });
    } else {
      setSelectedBuildingOrder(searchParam);
    }
  }

  async function acceptAndRejectRequest(request, is_accepted) {
    // history.push({pathname:"/complete-order",state:{id}})
    var temp = { ...request };
    temp.building_id = selected_buildingOrder;
    temp.id = request.order_id;
    temp = { ...temp, is_accepted };
    temp.user_id = user.user_id;
    set_mdl_progress(true);
    const order_options = {
      method: "POST",
      headers: {
        "Content-Type": "application/json",
        Authorization: "Token " + user.token,
        entityid: selected_buildingOrder,
        appversion: var_app_version,
      },
      body: JSON.stringify(temp),
    };
    await fetch(acceptOrRejectOrder, order_options)
      .then((res) => res.json())
      .then((res) => {
        if (res.code && res.code === 401) {
          addToast("Session expired. Please Login again.", {
            appearance: "error",
            autoDismiss: true,
          });
          //SessionExpire();
          localStorage.removeItem("user");
          localStorage.removeItem("building");
          setUser(null);
          setBuildingInfo(null);
        } else {
          if (res.code === 200) {
            getBuildingOrders(page, limit);
            addToast(res.message, {
              appearance: "success",
              autoDismiss: true,
            });
          } else {
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
            addToast(res.message, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        }
      })
      .catch((error) => {
        console.log("error:", error);
      });
    set_mdl_progress(false);
  }

  function deleteOrderApiCall(
    unit_uuid,
    sortBy,
    order_number,
    scheduler_email,
    building_name,
  ) {
    var params = {};
    params = { ...params, order_unit_uuid: unit_uuid };
    params = { ...params, scheduler_email: scheduler_email };
    if (sortBy === 2 || sortBy === 4) {
      params = { ...params, order_id: order_number };
    } else {
      params = { ...params, order_number: order_number };
    }
    params = { ...params, building_name: building_name };
    const requestOptionsOrder = {
      method: "DELETE",
      headers: {
        "Content-Type": "application/json",
        entityid: selected_buildingOrder,
        appversion: var_app_version,
      },
      body: JSON.stringify(params),
    };
    set_mdl_progress(true);
    fetch(deleteOrder, requestOptionsOrder)
      .then((response) => response.json())
      .then((res) => {
        if (res.code !== 200) {
          if (res?.version && res?.version !== var_app_version) {
            set_is_app_version_outdated(true);
          }
        }
        if (res.status === 200) {
          getBuildingOrders(1, 10, sortBy);
        }
        addToast(res.message, {
          appearance: res.status === 200 ? "success" : "error",
          autoDismiss: true,
        });
        set_mdl_progress(false);
      })
      .catch((error) => {
        set_mdl_progress(false);
        console.log("Error:::::", error);
      });
  }

  function onChangeSortBy(event, { value }) {
    const prevValue = sortBy;
    const isPrev24 = prevValue === 2 || prevValue === 4;
    const isNew24 = value === 2 || value === 4;
    if ((isPrev24 && !isNew24) || (!isPrev24 && isNew24)) {
      set_current_sorted({
        sort_by: "",
        sort_by_value: "",
      });
    }
    set_order_filter(value);
    setSortBy(value);
  }

  function goForEditDraft(id) {
    history.push(
      `/building-orders/automatic-followup-order-request/${id}?order-list=true&orderFilter=${var_order_filter}`,
    );
  }

  function goViewDetail(id, unit_number) {
    history.push({
      pathname: "/order-detail",
      state: {
        id,
        unit_number,
        orderlist: true,
        orderFilter: var_order_filter,
      },
    });
  }

  async function downloadReport() {
    set_mdl_progress(true);
    const requestHeaders = {
      headers: {
        entityid: selected_buildingOrder,
        appversion: var_app_version,
      },
    };
    try {
      await fetch(downloadPestTracker + selected_buildingOrder, requestHeaders)
        .then((res) => res.json())
        .then((res) => {
          if (res.code !== 200) {
            if (res?.version && res?.version !== var_app_version) {
              set_is_app_version_outdated(true);
            }
          }
          if (res.statusCode === 200) {
            addToast(res.body.success, {
              appearance: "success",
              autoDismiss: true,
            });
          } else {
            addToast(res?.body?.error, {
              appearance: "error",
              autoDismiss: true,
            });
          }
        });
    } catch (error) {
      console.error("Error:", error);
    }
    set_mdl_progress(false);
  }
  return (
    <div className="app-content">
      {!renderedByTab && (
        <div className="app-backto-prev-page">
          <div
            className="app-goback-button"
            onClick={() => {
              history.replace("/home");
            }}
          >
            <Icon name="arrow left" /> Go Back
          </div>
        </div>
      )}

      <div className="app-card">
        <div className="app-card-header">
          <div className="app-card-title" style={{ color: "black" }}>
            {"Order List (" + orders.length + ")"}
            <Popup
              content="Download Pest Tracker Report" // Text to show on hover
              trigger={
                <img
                  style={{ marginLeft: "5px", cursor: "pointer" }}
                  onClick={downloadReport}
                  width="28"
                  height="25"
                  src="/excel.png"
                  alt="document"
                />
              }
              position="top center" // Position of the tooltip
            />
          </div>
          <div
            className="app-card-action"
            style={{ display: "flex", gap: "16px" }}
          >
            <div className="app-content-action-right search-orders-list">
              {sortBy != 2 && sortBy != 4 && (
                <Search
                  placeholder="Search Unit Number"
                  onSearchChange={(value) => doSearch(value)}
                  showNoResults={false}
                  value={searchQuery}
                />
              )}
            </div>
            <Form.Select
              className="sortby_optionss"
              id="sortby_optionss"
              name="sortby_optionss"
              placeholder="Sort By"
              label="Status: "
              onChange={onChangeSortBy}
              value={sortBy}
              options={[
                { key: 3, text: "All Orders", value: 3 },
                { key: 0, text: "In Progress / Scheduled", value: 0 },
                { key: 1, text: "Completed", value: 1 },
                { key: 2, text: "Draft", value: 2 },
                { key: 4, text: "Recommended", value: 4 },
              ]}
            />
          </div>
        </div>

        <div className="app-table-wrapper">
          <Table sortable unstackable>
            <Table.Header className="main-home-table">
              {sortBy != 2 && sortBy != 4 ? (
                <Table.Row>
                  <Table.HeaderCell
                    // icon={<Icon name="home" size="large" />}
                    sorted={
                      current_sort && current_sort.sort_by === "order_number"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "order_number",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "order_number",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    title="Order #"
                  >
                    Order #
                    {current_sort?.sort_by !== "order_number" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Unit #">Unit #</Table.HeaderCell>
                  <Table.HeaderCell title="PO/MO/WO">
                    PO/MO/WO #
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Pest">Pest</Table.HeaderCell>
                  <Table.HeaderCell title="Treatment">
                    Treatment
                  </Table.HeaderCell>

                  <Table.HeaderCell title="Current order status">
                    Status
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    sorted={
                      current_sort && current_sort.sort_by === "work_date"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "work_date",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "work_date",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    // icon={<Icon name="home" size="large" />}
                    title="Scheduled date"
                  >
                    {sortBy ? "Work" : "Schedule"} Date
                    {current_sort?.sort_by !== "work_date" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Order scheduler">
                    Time Window
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    Actions
                  </Table.HeaderCell>
                </Table.Row>
              ) : sortBy === 2 ? (
                <Table.Row>
                  <Table.HeaderCell
                    sorted={
                      current_sort &&
                      current_sort.sort_by === "purchase_order_number"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "purchase_order_number",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "purchase_order_number",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    title="PO/MO/WO"
                  >
                    PO/MO/WO #
                    {current_sort?.sort_by !== "purchase_order_number" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="No. of units">
                    Units
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Treatment">
                    Treatment
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    sorted={
                      current_sort && current_sort.sort_by === "order_date_time"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "order_date_time",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "order_date_time",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    title="Saved Date"
                  >
                    Created Date
                    {current_sort?.sort_by !== "order_date_time" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Note">Note</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    Actions
                  </Table.HeaderCell>
                </Table.Row>
              ) : sortBy === 4 ? (
                <Table.Row>
                  <Table.HeaderCell
                    sorted={
                      current_sort &&
                      current_sort.sort_by === "purchase_order_number"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "purchase_order_number",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "purchase_order_number",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    title="PO/MO/WO"
                  >
                    PO/MO/WO #
                    {current_sort?.sort_by !== "purchase_order_number" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="No. of units">
                    Units
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Treatment">
                    Treatment
                  </Table.HeaderCell>
                  <Table.HeaderCell
                    sorted={
                      current_sort && current_sort.sort_by === "order_date_time"
                        ? current_sort.sort_by_value === "ASC"
                          ? "ascending"
                          : "descending"
                        : null
                    }
                    onClick={() => {
                      if (current_sort?.sort_by_value === "ASC") {
                        set_current_sorted({
                          sort_by: "order_date_time",
                          sort_by_value: "DESC",
                        });
                      } else {
                        set_current_sorted({
                          sort_by: "order_date_time",
                          sort_by_value: "ASC",
                        });
                      }
                    }}
                    title="Recommended Date"
                  >
                    Recommended Date
                    {current_sort?.sort_by !== "order_date_time" && (
                      <Icon size="20" name="sort" color="black" />
                    )}
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Note">Note</Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    Actions
                  </Table.HeaderCell>
                </Table.Row>
              ) : (
                <Table.Row>
                  <Table.HeaderCell title="No. of units">
                    Units
                  </Table.HeaderCell>
                  <Table.HeaderCell title="PO/MO/WO">
                    PO/MO/WO #
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Scheduler Name">
                    Scheduler
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Scheduler Email">
                    Email
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Date of request">
                    Requested Date
                  </Table.HeaderCell>
                  <Table.HeaderCell title="Current request Status">
                    Status
                  </Table.HeaderCell>
                  <Table.HeaderCell textAlign="center">
                    Actions
                  </Table.HeaderCell>
                </Table.Row>
              )}
            </Table.Header>
            <Table.Body>
              {sortBy != 2 &&
                sortBy != 4 &&
                orders &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>{order.order_number}</Table.Cell>
                    <Table.Cell>{order.unit_number}</Table.Cell>
                    <Table.Cell>
                      {order?.purchase_order_number || "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order.treatment_name?.toLowerCase() === "fullbuilding"
                        ? "N/A"
                        : order.pest_name || "N/A"}
                    </Table.Cell>
                    <Table.Cell>{order.treatment_name?.toLowerCase() === "activate treatment" ? "Activate (Actisol) Treatment" : (order.treatment_name || "N/A")}</Table.Cell>
                    <Table.Cell className="td-status">
                      {order.order_status === "posted" && (
                        <div style={{ color: "green" }}>Posted</div>
                      )}
                      {order.order_status === "completed" && (
                        <div style={{ color: "#05881F" }}>Completed</div>
                      )}
                      {order.order_status === "scheduled" && (
                        <div style={{ color: "#2196f3" }}>Scheduled</div>
                      )}
                      {order.order_status === "in progress" && (
                        <div style={{ color: "#FA8C16" }}>In Progress</div>
                      )}
                    </Table.Cell>
                    <Table.Cell>
                      {order.schedule_date &&
                      isValid(new Date(order.schedule_date))
                        ? moment(order.schedule_date).format("l")
                        : "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order.time_range ? order.time_range : "N/A"}
                    </Table.Cell>

                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      {order.order_status != "completed" ? (
                        <>
                          <Label
                            color="red"
                            onClick={() => {
                              set_order_to_delete(order);
                              set_open_delete_modal(true);
                            }}
                          >
                            Delete
                          </Label>
                          <Label
                            color="blue"
                            onClick={() =>
                              goViewDetail(order.order_id, order.unit_number)
                            }
                          >
                            View
                          </Label>
                        </>
                      ) : (
                        <Label
                          color="blue"
                          onClick={() => {
                            set_selected_order(order.order_number);
                            set_pdf_url(viewPdfURL + order.order_number);
                            set_open_pdf_viewer(true);
                          }}
                        >
                          View Report
                        </Label>
                      )}
                    </Table.Cell>
                  </Table.Row>
                ))}
              {sortBy == 2 &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {order?.purchase_order_number || "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((unit) => unit.unit_number)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((treatment) => treatment.treatment_name?.toLowerCase() === "activate treatment" ? "Activate (Actisol) Treatment" : treatment.treatment_name)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order.date && isValid(new Date(order.date))
                        ? moment(order.date).format("l")
                        : "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note) // Remove empty notes
                        .slice(0, 3)
                        .join(", ")}
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note).length > 3
                        ? "..."
                        : ""}
                    </Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      <Label
                        color="green"
                        onClick={() => goForEditDraft(order?.order_id)}
                      >
                        Edit
                      </Label>
                      <Label
                        color="red"
                        onClick={() => {
                          set_order_to_delete(order);
                          set_open_delete_modal(true);
                        }}
                      >
                        Delete
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
              {sortBy == 4 &&
                orders.map((order, i) => (
                  <Table.Row key={i}>
                    <Table.Cell>
                      {order?.purchase_order_number || "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((unit) => unit.unit_number)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.slice(0, 3)
                        .map((treatment) => treatment.treatment_name?.toLowerCase() === "activate treatment" ? "Activate (Actisol) Treatment" : treatment.treatment_name)
                        .join(", ")}
                      {order?.units?.length > 3 ? "..." : ""}
                    </Table.Cell>
                    <Table.Cell>
                      {order.date && isValid(new Date(order.date))
                        ? moment(order.date).format("l")
                        : "N/A"}
                    </Table.Cell>
                    <Table.Cell>
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note) // Remove empty notes
                        .slice(0, 3)
                        .join(", ")}
                      {order?.units
                        ?.map((unit) => unit.note)
                        .filter((note) => note).length > 3
                        ? "..."
                        : ""}
                    </Table.Cell>
                    <Table.Cell
                      className="td-action"
                      collapsing
                      textAlign="right"
                    >
                      <Label
                        color="green"
                        onClick={() => goForEditDraft(order?.order_id)}
                      >
                        Edit
                      </Label>
                      <Label
                        color="red"
                        onClick={() => {
                          set_order_to_delete(order);
                          set_open_delete_modal(true);
                        }}
                      >
                        Delete
                      </Label>
                    </Table.Cell>
                  </Table.Row>
                ))}
            </Table.Body>
          </Table>
          {orders.length === 0 && (
            <div className="nodata-placeholder">
              There is no order to display.
            </div>
          )}
        </div>
        <div>
          <AppPagination
            limit={limit}
            setLimit={setLimit}
            page={page}
            setPage={setPage}
            rowsTotal={orders.length}
            totalCount={totalOrders}
            showAll={true}
          />
        </div>
        {/***** MODAL: DELETE CONFIRMATION **************************************************************************/}
        <Modal
          id="mdl-pdf-viewer"
          dimmer={"inverted"}
          open={open_pdf_viewer}
          onClose={() => {
            set_open_pdf_viewer(false);
            set_pdf_url(null);
          }}
        >
          <CMP_PDF_VIEWER
            set_mdl_open={set_open_pdf_viewer}
            pdf_url={pdf_url}
            set_pdf_url={set_pdf_url}
            var_modaltitle={"Order #" + selected_order}
          />
        </Modal>
      </div>

      {/***** MODAL: PROGRESS **************************************************************************/}

      <Modal
        id="mdl-progress"
        dimmer={"inverted"}
        open={var_mdl_progress}
        closeOnDimmerClick={false}
        closeOnEscape={false}
        onClose={() => {}}
      >
        <MDL_PROGRESS
          set_mdl_open={set_mdl_progress}
          var_modaltitle="Please wait"
          var_message={"Please wait..."}
        ></MDL_PROGRESS>
      </Modal>

      {/***** END MODAL: PROGRESS **************************************************************************/}

      {/***** MODAL: MDL_DELETE **************************************************************************/}

      <Modal
        id="mdl-delete-confirmation"
        dimmer={"inverted"}
        size="tiny"
        open={open_delete_modal}
        onClose={() => {
          set_open_delete_modal(false);
        }}
      >
        <MDL_DELETE
          title={"Delete Order"}
          heading={
            order_to_delete?.order_number
              ? `Are you sure you want to delete Order #${order_to_delete.order_number}?`
              : "Are you sure you want to delete this order?"
          }
          message={
            order_to_delete?.order_status === "in progress" ||
            order_to_delete?.order_status === "scheduled" ||
            order_to_delete?.order_status === "posted"
              ? `A deletion request email will be sent to the scheduler for approval.`
              : "This action will permanently remove the order from the system."
          }
          onCancel={() => set_open_delete_modal(false)}
          onSubmit={() => {
            if (order_to_delete) {
              deleteOrderApiCall(
                order_to_delete.unit_uuid,
                sortBy,
                order_to_delete.order_number || order_to_delete.order_id,
                order_to_delete.scheduler_email,
                order_to_delete.building_name,
              );
            }
          }}
        ></MDL_DELETE>
      </Modal>

      {/***** END MODAL: MDL_DELETE **************************************************************************/}
    </div>
  );
}
